module.exports = __webpack_public_path__ + "ac21207de8c542b0b918e0d111cad729.svg";